<template>
    <div class="mdc-snackbar" ref="snackbarContainer" @MDCSnackbar:closed="onClosed">
        <div class="mdc-snackbar__surface">
            <div class="mdc-snackbar__label"
                role="status"
                aria-live="polite">
                <slot />
            </div>
            <div class="mdc-snackbar__actions">
                <button class="mdc-icon-button mdc-snackbar__dismiss material-icons" title="Dismiss">close</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {MDCSnackbar} from '@material/snackbar';

    export default {
        props: ['open'],
        data() {
            return {
                snackbar: undefined,
            };
        },
        mounted() {
            this.snackbar = new MDCSnackbar(this.$refs.snackbarContainer);
            this.snackbar.timeoutMs = 4000;
            if(this.open) this.snackbar.open();
        },
        methods: {
            onClosed() {
                console.log('closed - snack');
                this.$emit('closed');
            }
        },
        beforeDestroy () {
            this.snackbar.destroy();
        },
        watch: {
            open(value) {
                console.log(`open changed: ${value}`);
                if(value){
                    this.snackbar.open();
                }else{
                    this.snackbar.close();
                }
            }
        }
    }

</script>